import useSeo from "@/hooks/useSeo";
import useFavorites from "@/hooks/useFavorites";
import { actors } from "@/mocks/actors";
import Breadcrumb from "@/components/base/Breadcrumb";
import ActorCard from "@/components/base/ActorCard";

export default function ActorList() {
  const { isActorFav, toggleActor } = useFavorites();

  useSeo({
    title: "热门演员 - 我的老婆姐姐影视资讯",
    description:
      "我的老婆姐姐演员库，收录热门电视剧与电影演员资料、个人简介与代表作品，帮助影迷快速了解喜欢的演员。",
    keywords: "热门演员,演员资料,演员简介,代表作品,我的老婆姐姐",
  });

  return (
    <div className="w-full px-4 md:px-8 py-6 md:py-8">
      <Breadcrumb items={[{ label: "演员" }]} />

      <div className="mt-5">
        <h1 className="font-heading font-extrabold text-2xl md:text-3xl text-foreground-950">
          热门演员
        </h1>
        <p className="mt-2 text-sm md:text-base text-foreground-500 max-w-2xl leading-relaxed">
          收录本站影视作品中出现的演员资料，点击头像可查看个人简介与代表作品。
        </p>
      </div>

      <div className="mt-7 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-5">
        {actors.map((a) => (
          <ActorCard
            key={a.id}
            actor={a}
            isFav={isActorFav(a.id)}
            onToggleFav={toggleActor}
          />
        ))}
      </div>
    </div>
  );
}